import React from "react";
import { dateFormat } from '../../../core/helper/date-format';
import { Link } from "react-router-dom";

export default function TradeHistoryTable(props) {
  const { coindcxDecimal = {} } = props
  return (
    <>
      <table className="table">
        <thead>
          {/* <th>S.no</th> */}
          <th>Date</th>
          <th>Pair</th>
          <th>Side</th>
          <th>Price</th>
          <th>Filled</th>
          <th>Total</th>
          <th>Fees</th>
          <th>Fee Type</th>
          <th>Role</th>
          <th>Status</th>
        </thead>
        <tbody>
          {
            props.traHisData && props.traHisData.length > 0 &&
            props.traHisData.map((elem, i) => {
              const {
                _id: tradeId = "",
                MappingOrders = {},
                orderId = "",
                type: side = "",
              } = elem;
              const {
                pairName = "",
                pair = {},
                Profit = [],
                dateTime = "",
                orderType = "",
                tradePrice = 0,
                filledAmount = 0,
                role = "",
                status = "Filled",
              } = MappingOrders;
              const clrClassName = side == "buy" ? "color-green" : "color-red";
              const getDecimal = coindcxDecimal[pairName.replace("_", "")] || null
              const { amountDecimal = 2, priceDecimal = 2 } = pair;

              const { currency: profitCurrency = {}, totalFees = 0 } = Profit[0] ? Profit[0] : {};

              const {
                currencySymbol: profit_currencySymbol = "",
                siteDecimal: profit_siteDecimal = 2,
              } = profitCurrency;

              let userFeeReduced = (Profit && Profit[0]) ? Profit[0].userFeeReduced : "";
              const feesDecimal =
                userFeeReduced !== "tradeFeeVoucher" &&
                  userFeeReduced !== "fanToken"
                  ? profit_siteDecimal
                  : side == "buy"
                    ? amountDecimal
                    : priceDecimal;

              if (userFeeReduced == "tradeFeeVoucher") {
                userFeeReduced = "Voucher";
              } else if (userFeeReduced == "fanToken") {
                userFeeReduced = "BKC";
              } else if (userFeeReduced == "respective") {
                userFeeReduced = "Respective";
              }

              return (
                <tr key={i}>
                  {/* <td data-label="i">{i}</td> */}
                  <td data-label="Pair">{dateFormat(dateTime)}</td>
                  <td data-label="Pair">
                    {pairName ? (
                      <Link to={"/spot/" + pairName} className="text-white">
                        {pairName.replace("_", "/")}
                      </Link>
                    ) : (
                      ""
                    )}
                  </td>
                  <td
                    data-label="Type"
                    className={"capitalizeText " + clrClassName}
                  >
                    {side}
                  </td>
                  <td data-label="Price">{props.decimalValue(tradePrice, getDecimal?.base_currency_precision >= 0 ? getDecimal?.base_currency_precision : priceDecimal)}</td>
                  <td data-label="Filled">
                    {filledAmount.toFixed(getDecimal?.target_currency_precision >= 0 ? getDecimal?.target_currency_precision : amountDecimal)}
                  </td>
                  <td data-label="Total">
                    {props.decimalValue((filledAmount * tradePrice), getDecimal?.base_currency_precision >= 0 ? getDecimal?.base_currency_precision : priceDecimal)}
                  </td>
                  <td data-label="Fees">
                    {props.decimalValue(totalFees, feesDecimal)} {profit_currencySymbol}
                  </td>
                  <td data-label="Type">{userFeeReduced}</td>
                  <td data-label="Role" className="capitalizeText">
                    {role}
                  </td>
                  <td data-label="Status">
                    <button
                      className="popup-modal-button-my-orders capitalizeText"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      onClick={() => {
                        props.getOrderDetail_call(tradeId);
                      }}
                    >
                      {status}
                    </button>
                  </td>
                </tr>
              );
            })
          }
          {props.traHisData && props.traHisData.length === 0 && (
            <tr colSpan={8}>
              <td className="color-white" colSpan="7">
                No Active Orders Found!
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
}
